/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ItineratorError,
  ItineratorGetItinerariesParams,
  ItineratorItinerary,
  ItineratorItineraryList,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Itineraries<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Itinerary
   * @name GetItineraries
   * @summary List all itineraries
   * @request GET:/itineraries
   * @secure
   */
  getItineraries = (query?: ItineratorGetItinerariesParams, params: RequestParams = {}) =>
    this.request<ItineratorItineraryList, ItineratorError>({
      path: `/itineraries`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Itinerary
   * @name GetItineraryBySlug
   * @summary Find a itinerary by slug
   * @request GET:/itineraries/{slug}
   * @secure
   */
  getItineraryBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorItinerary, ItineratorError>({
      path: `/itineraries/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
